import { Component, OnChanges, SimpleChanges, OnInit, input } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { BrowserUtils } from '../../../utils/browser.utils';
import { CheckInEntryInterrupt, TravelDocument } from '../../../models/governance-content.payload';
import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import * as tracking from '../../../actions/tracking';
import { MicroServicesService } from '../../core/services/micro-services.service';
import { BookingService } from '../../core/services/booking.service';
import { constants } from '../../../constants/constants';
import { TrackVisitHealthCenterClickAction } from 'src/app/actions/tracking';

@Component({
    selector: 'app-governance-content',
    templateUrl: './modal-governance-content.component.html',
    styleUrls: ['./modal-governance-content.component.scss'],
    providers: [BrowserUtils],
    standalone: false
})
export class ModalGovernanceContentComponent implements OnInit, OnChanges {
	public readonly bundle = input<any>(null);
	public readonly layoutState = input<string>();

	checkInEntryInterrupt$: Observable<CheckInEntryInterrupt>;
	showGovernanceContent: boolean;
	protocols: TravelDocument[];
	brandName: string;

	constructor(
		private readonly store: Store<fromRoot.AppState>,
		public microservices: MicroServicesService,
		private readonly bookingService: BookingService,
		public browserUtils: BrowserUtils
	) {
		this.checkInEntryInterrupt$ = this.store.pipe(select(fromRoot.getGovernanceContentCheckin));
		this.checkInEntryInterrupt$.subscribe((content) => {
			if (!content) return;
			this.protocols = content.items;
		});
	}

	ngOnInit() {
		this.brandName = this.bookingService.getBrand();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes['layoutState'] || !changes['layoutState'].currentValue) return;

		if (changes['layoutState'].currentValue.openedModalName === constants.MODAL.HEALTH_SAFETY_PROTOCOLS) {
			this.showGovernanceContent =  true;
			this.store.dispatch(new tracking.TrackReadyToBoardViewAction());
		} else {
			this.showGovernanceContent = false;
		}
	}

	public closeModal(): void {
		this.showGovernanceContent = false;
		this.store.dispatch(new olci.CloseModalAction());
	}

	public onVisitHealthCenter(): void {
		this.closeModal();
		this.store.dispatch(new TrackVisitHealthCenterClickAction());
		this.browserUtils.openInNewTab(constants.ROUTES.HEALTH_CENTER);
	}
}
